import { useState } from 'react';
import { useSearchParams, useNavigate, Link } from 'react-router-dom';
import { ShieldCheck, Eye, EyeOff } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { toast } from 'sonner';
import api from '@/lib/api';

export default function ResetPassword() {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const token = params.get('token') || '';
  const [form, setForm] = useState({ password: '', confirm: '' });
  const [show, setShow] = useState(false);
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (form.password.length < 8) { toast.error("8 caractères minimum"); return; }
    if (form.password !== form.confirm) { toast.error("La confirmation ne correspond pas"); return; }
    setBusy(true);
    try {
      await api.post('/admin/reset-password', { token, new_password: form.password });
      toast.success("Mot de passe modifié, vous pouvez vous connecter");
      navigate('/admin/login');
    } catch (err) { toast.error(err.response?.data?.detail || "Lien invalide"); }
    finally { setBusy(false); }
  };

  return (
    <div className="min-h-screen bg-slate-50 flex items-center justify-center p-4">
      <div className="w-full max-w-sm bg-white border border-slate-200 rounded-2xl p-8" data-testid="reset-password-page">
        <img src="/logo-header.png" alt="Plume et Pion" className="h-24 w-auto mx-auto" />
        <h1 className="text-xl font-bold text-slate-900 text-center mt-4">Nouveau mot de passe</h1>
        {!token ? (
          <div className="mt-4 text-sm text-rose-600 text-center" data-testid="reset-no-token">Lien incomplet. <Link to="/admin/login" className="underline">Retour à la connexion</Link></div>
        ) : (
          <form onSubmit={submit} className="mt-6 space-y-4">
            <div>
              <Label className="text-xs font-medium text-slate-500">Nouveau mot de passe (8 caractères minimum)</Label>
              <Input type={show ? 'text' : 'password'} value={form.password} onChange={e => setForm(f => ({ ...f, password: e.target.value }))} className="mt-1 rounded-lg" autoComplete="new-password" data-testid="reset-password-input" />
            </div>
            <div>
              <Label className="text-xs font-medium text-slate-500">Confirmer</Label>
              <Input type={show ? 'text' : 'password'} value={form.confirm} onChange={e => setForm(f => ({ ...f, confirm: e.target.value }))} className="mt-1 rounded-lg" autoComplete="new-password" data-testid="reset-confirm-input" />
            </div>
            <button type="button" onClick={() => setShow(s => !s)} className="text-xs text-slate-500 flex items-center gap-1" data-testid="reset-toggle-visibility">{show ? <EyeOff className="h-3.5 w-3.5" /> : <Eye className="h-3.5 w-3.5" />} {show ? 'Masquer' : 'Afficher'}</button>
            <Button type="submit" className="w-full rounded-full" disabled={busy} data-testid="reset-submit-btn"><ShieldCheck className="h-4 w-4 mr-2" /> {busy ? '...' : 'Enregistrer le mot de passe'}</Button>
          </form>
        )}
      </div>
    </div>
  );
}
